module.exports = __webpack_public_path__ + "static/media/close-icon-gray.3377e894.svg";